import {Action, Dispatch} from 'redux';
import {ApiActionCall, ApiActionTypes} from '../Api';
import {CommonActionTypes} from '../../../types/actions/Common.action';
import {
  IPriceCorrection,
  PriceCorrectionType,
} from '../../../types/models/Price';
import {showError, showMessage} from '../Common';
import {
  PRICE_CORRECTION_DECREASE_URL,
  PRICE_CORRECTION_INCREASE_URL,
} from '../../../@crema/services/ApiConfig';
import {
  PRICE_CORRECTION,
  PRICE_CORRECTION_ERROR,
  PRICE_CORRECTION_SUCCESS,
  PriceCorrectionActions,
} from '../../../types/actions/Exchanges/PriceCorrection.actions';

export const savePriceCorrection = (
  targetPrice: number,
  type: PriceCorrectionType,
  exchange: string,
) => async (
  dispatch: Dispatch<
    ApiActionCall | CommonActionTypes | PriceCorrectionActions
  >,
) => {
  dispatch({type: PRICE_CORRECTION});
  const onSuccess = (payload: IPriceCorrection) => (
    dispatch: Dispatch<Action>,
  ) => {
    dispatch(showMessage('Successfully saved'));
    dispatch({
      type: PRICE_CORRECTION_SUCCESS,
      payload,
    });
  };
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    dispatch({type: PRICE_CORRECTION_ERROR});
    dispatch(showError(message));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: createUrl(type, exchange),
      method: 'POST',
      data: {
        targetPrice,
      },
      label: `Save price ${type} correction`,
      onSuccess,
      onFailure,
    },
  });
};

const createUrl = (type: PriceCorrectionType, exchange: string): string => {
  const url =
    type === 'increase'
      ? PRICE_CORRECTION_INCREASE_URL
      : PRICE_CORRECTION_DECREASE_URL;
  return url.replace(':exchangeSlug', exchange);
};
